const ArCallingQueueRoute = {
  path: '/accounting/arcallingqueue',
  load: () => import('./ArCallingQueue'),
  protected: true,
};

export { ArCallingQueueRoute };
